import { Link } from 'react-router';
import { Table, Button, Breadcrumb, BPanel } from '@sketchpixy/rubix';
import React from 'react';

import { Meteor } from 'meteor/meteor';

import { Reactive } from '../common/Reactive.mixin.js';

import { Options } from '../../collections/flights-type/options';
import OptionListComponent from './component-options-list';

@Reactive({
	subscriptions: ["flights-type"],
	options: Options.find({}),
})
export default class OptionsListPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	renderOptions() {
		return this.props.options.map((option) => (
			<OptionListComponent key={option._id} option={option} />
		));
	}

	render() {
		return (
			<div> 
				<Breadcrumb>  
					<Breadcrumb.Item>
						Options
					</Breadcrumb.Item>
					<Breadcrumb.Item active>
						Liste des options
					</Breadcrumb.Item>
					<Breadcrumb.Item>
						<Link to="/options-add"><Button bsStyle="success">Ajouter</Button></Link>
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Liste des options">
					<Table responsive>
						<thead>
							<tr>
								<th>Nom</th>
								<th>Prix par passager</th>
								<th>Date de création</th>
								<th>Dernière modification</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{this.renderOptions()}
						</tbody>
					</Table>
				</BPanel>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/options/OptionsList.page.js
 **/